module.exports = __webpack_public_path__ + "img/img28.b352a2df.svg";